import React, { useState } from 'react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';

interface PDFViewerProps {
    file: string
};

const PDFViewer : React.FC<PDFViewerProps> = (props) => {
  const [numPages, setNumPages] = useState<number>(0);

  const onDocumentLoadSuccess = (pdf: any) => {
    setNumPages(pdf.numPages);
  };

  const onDocumentLoadError = (error: Error) => {
    console.log(error, props.file);
    setNumPages(0);
  };

  let pages = [];
  for (let i = 1; i <= numPages; i++)
    pages.push(i);

  return (
    <div style={{
        width: "100%",
        height: "100%",
        overflow: "scroll",
        filter: "drop-shadow(0 0 0.3rem gray)"
    }}>
        <Document file={props.file}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={onDocumentLoadError}>
            {
                pages.map((value:number) => {
                    return (<Page key={value} pageNumber={value} />);
                })
            }
        </Document>
    </div>
  );
};

export default PDFViewer;